<template>
  <ul class="unitselect">
    <Checkbox
      v-for="(xx, index) in units"
      @on-change="unitChange(xx, index)"
      :key="index"
      v-model="xx.select"
      >{{ xx.name }}</Checkbox
    >

  </ul>
</template>
<script>
export default {
  props: ["unit","units"],
  data() {
    return {
      
    };
  },
  methods: {
    unitChange(xx, index) {

      // xx.select = !xx.select;
      this.$emit("on-change", {
        index: index,...xx
      });
    },
    ff() {
      for (let i = 0; i < this.units.length; i++) {
        this.units[i].select = false;
        for (let j = 0; j < this.unit.length; j++) {
          if (this.unit[j].unit[0] == this.units[i].name) {
            this.units[i].select = true;
          }
        }
      }
    },
  },
  mounted() {
    this.ff();
  },
  watch: {
    unit(v) {
      //console.log(v);
      this.ff();
    },
  },
};
</script>
<style>
.unitselect {
  display: flex;
}
.unitselect li {
  padding: 2px 10px;
  border: solid 2px #ccc;
}
.unitselect li.active {
  border: solid 2px #fb2020;
}
</style>


// WEBPACK FOOTER //
// src/components/wuliu/kehu/baojia/unitBoxDanjia.vue